module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/tablet-aae303cb71ff52ab2fcac054b882f9e5.webp";